import { breakpoints, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const HeaderCategoryGroupRoot = styled.section`
  display: flex;
  align-items: center;
`;

export const HeaderCategoryTitle = styled.h4`
  color: var(--text-soft);
  text-transform: uppercase;
  ${typographyV2.bodyXs};
  padding: 0 8px 0 24px;
`;

export const HeaderItems = styled.nav`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 8px;

  &.options {
    gap: 0px;
  }

  @media ${breakpoints.xl} {
    gap: 12px;
  }
`;
